<template>
   <dd-card class="slim-card" :class="{'hidden-card': selectedEmails.length <= 1}">
    <div class="flex-row gap-md">
      <dd-button
          id="multiple-selection-match"
          small
          v-if="unmatchedEmails.length > 0"
          icon="mdi mdi-link-variant"
          @click="matchEmails"
      >
        {{unmatchedEmails.length}} koppelen
      </dd-button>
      <dd-button
          small
          v-if="matchedEmails.length > 0"
          icon="mdi mdi-link-variant"
          type="danger"
          @click="unmatchEmails"
      >
        {{matchedEmails.length}} ontkoppelen
      </dd-button>
      <dd-button
          small
          v-if="unprocessedEmails.length > 0"
          icon="mdi mdi-check"
          @click="processEmails"
      >
        {{unprocessedEmails.length}} verwerken
      </dd-button>
      <dd-button
          small
          v-if="processedEmails.length > 0"
          icon="mdi mdi-check"
          type="danger"
          @click="unprocessEmails"
      >
        {{processedEmails.length}} aanmerken als onverwerkt
      </dd-button>      
      <dd-icon-button
        icon="mdi mdi-close"
        title="Deselecteer emails"
        size="xl"
        @click="clearSelected"
      ></dd-icon-button>
    </div>
  </dd-card>
</template>

<script>
import EmailApi from '~/api/email';
import ViewStateEnum from '../enums/ViewStateEnum';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "MultipleSelectionComponent.vue",
  methods: {
    ...mapActions('email', [
      "loadEmails",
      "showMatchEmail",
      "setSelectedEmails",
      "setMatchState",
    ]),
    async matchEmails(){
      await this.showMatchEmail(this.unmatchedEmails.map(email => email.id));
    },
    async unmatchEmails(){
      await EmailApi.unmatchMultipleEmails(this.matchedEmails.map(email => email.id));
      await this.loadEmails();
    },
    async processEmails(){
      await EmailApi.processMultipleEmails(this.unprocessedEmails.map(email => email.id));
      await this.loadEmails();
    },
    async unprocessEmails(){
      await EmailApi.unprocessMultipleEmails(this.processedEmails.map(email => email.id));
      await this.loadEmails();
    },
    clearSelected(){
      if ( this.viewState === ViewStateEnum.VIEW){
        this.setSelectedEmails([ this.firstSelectedEmail.id ]);
      } else {
        this.setSelectedEmails([]);
      }
    }
  },
  computed: {
    ...mapGetters("email", [ 
      "selectedEmails", 
      "firstSelectedEmail",
      "viewState"
    ]),
    unmatchedEmails(){
      return this.selectedEmails.filter(email => !email.customer_id);
    },
    matchedEmails(){
      return this.selectedEmails.filter(email => email.customer_id);
    },
    unprocessedEmails(){
      return this.selectedEmails.filter(email => email.processed === 0);
    },
    processedEmails(){
      return this.selectedEmails.filter(email => email.processed === 1);
    },
  },
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.slim-card{
  padding-top: $spacing-md !important;
  padding-bottom: $spacing-md !important;
}
.hidden-card{
  display: none !important;
  height: 0 !important;
  transition: all 1s ease;
}
</style>
